<div class="mb-promo">
    <HeaderComponent
            :path-image-bck="'2023'"
    />
    <main>
        <section>
            <div class="wide-content-wrapper-cnt">
                <div class="chart-wrapper-intro">
                    <h2 v-html="t('landing.title.2023.chart')"></h2>
                    <p v-html="t('landing.text.2023.chart')"></p>
                </div>
                <div class="chart-wrapper">
                    <ImageBoxComponent
                            v-for="image in chartPreviousYear"
                            :key="image.id"
                            :image-path="image.imgPath"
                            :selected="image.selected"
                            :ranking="image.ranking"
                            type="chart"
                    ></ImageBoxComponent>

                    <ModalComponent></ModalComponent>
                </div>

                <div class="go-to-chart">
                    <ButtonComponent
                            :text="t('home.cta.chart')"
                            href="/lacartadelmulino/fiori-del-mulino/2023/classifica"
                    ></ButtonComponent>
                </div>
            </div>
        </section>

        <div class="wide-content-wrapper-cnt">
            <div class="general-rules tac"><div v-html="t('general.rules')"></div></div>
        </div>

    </main>
    <FooterComponent type="homepage"></FooterComponent>
</div>